import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  TextField,
  Button,
  Backdrop,
  CircularProgress,
  Box,
  Typography,
  Checkbox,
  Link,
  InputAdornment,
  IconButton,
  MenuItem,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useAuth } from "../context/auth";
import { useNavigate } from "react-router-dom";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { registerUser, skipUser , loginGuestUser } from "../helper/authentication";
import { toast } from "react-toastify";
import { getUser } from "../action/authActions";
import { strongPasswordSchema } from "../utils/passwordValidation";
import { countryCodes } from "../helper/commonFunctions";
import CustomTextField from "./CustomTextField";
import { useSelector } from "react-redux";

const errorTextStyle = {
  backgroundColor: "#00000075",
  color: "red",
  padding: "5px",
  borderRadius: "5px",
  fontSize: "12px",
};

const Register = () => {
  const [loading, setLoading] = useState(false);
  const authState = useSelector((state) => state.auth);
  const [user, setUser] = useState(null);
  const [showPass, setShowPass] = useState(false);
  const [showConfPass, setShowConfPass] = useState(false);
  const { loginUser } = useAuth();
  const [countryCode, setCountryCode] = useState("+44 United Kingdom");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const [authLoading, setAuthLoading] = useState(true);

  // useEffect(() => {
  //   if (authState.isAuthenticated) {
  //     navigate("/");
  //   } else {
  //     setAuthLoading(false);
  //   }
  // }, []);

  const handleClickShowPassword = () => setShowPass((show) => !show);
  const handleClickShowConfPassword = () => setShowConfPass((show) => !show);
  const handleMouseDownPassword = (e) => {
    e.preventDefault();
  };
  const handleMouseDownConfPassword = (e) => {
    e.preventDefault();
  };

  // const handleSkip = async () => {
  //   // "";
  //   try {
  //     setLoading(true);
  //     const data = await skipUser();
  //     if (!data?.skipRegister) {
  //       toast.error(data.message);
  //       return;
  //     }
  //     dispatch({ type: "SAVE_LOGGED_USER", payload: { is_skip: true } });
  //     dispatch(getUser("", "is_skip"));
  //     loginUser(data?.skipRegister);
  //     navigate(`/`);
  //   } catch (error) {
  //     toast.error(error.message);
  //     "";
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  
  
  
  const handleSkip = async () => {
    // "";
    try {
      setLoading(true);
      const deviceId = localStorage.getItem("mynetgoals.com-device-id");
      const data = await loginGuestUser(deviceId);
      if (!data?.token) {
        toast.error(data.message);
        return;
      }
      dispatch({ type: "SAVE_LOGGED_USER", payload: { ...data?.data } });
      localStorage.setItem("mynetgoals.com-userData", JSON.stringify(data?.data));
      // dispatch(getUser("", "is_skip"));
      loginUser(data?.token);


      navigate(`/`);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user != null) {
      dispatch({ type: "SAVE_LOGGED_USER", payload: user?.data });
      dispatch(getUser(user?.token, user?.data?.id));
      loginUser(user?.token);

      navigate(`/welcome`);
    }
  }, [user]);

  const registerForm = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      password: "",
      confirmPassword: "",
      terms: false,
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("First Name is required"),
      lastName: Yup.string().required("Last Name is required"),
      email: Yup.string()
        .email("Please enter valid email address")
        .test("email-check", "Please enter valid email address", (value) =>
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
        )
        .required("Email is required"),
      phoneNumber: Yup.number("Must be a number")
        .required("Phone Number is required")
        .test(
          "phone_number_check",
          "Please enter valid mobile number",
          (value) => {
            return value.toString().length == 10 ? true : false;
          }
        ),
      password: strongPasswordSchema("Password is required"),
      confirmPassword: Yup.string()
        .required("Confirm Password is required")
        .oneOf([Yup.ref("password"), null], "Passwords must match"),
      terms: Yup.bool().oneOf(
        [true],
        "You must accept the terms and conditions"
      ),
    }),
    validateOnChange: true,
    validateOnBlur: false,
    onSubmit: async (values, action) => {
      const userData = {
        ...values,
        phoneNumber: countryCode.split(" ")[0] + values.phoneNumber,
      };

      try {
        setLoading(true);
        const data = await registerUser(userData);
        if (!data?.token) {
          toast.error(data.message);
          return;
        }
        localStorage.removeItem("mynetgoals.com-userData");
        setUser(data);
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box className="RegisterDiv">
        <Box className="skip_option">
          <Box className="skip">
            <Button onClick={handleSkip}>
              Guest Login
              <ArrowForwardIosIcon className="ficon" />
            </Button>
          </Box>
        </Box>
        <Box className="form_wrapper">
          <Box className="form_inner">
            <Typography component="h2" className="form_head">
              REGISTER NOW!
            </Typography>
            <Typography component="p" className="form_sub_head">
              Join us to start sharing and voting today!
            </Typography>
            <form onSubmit={registerForm.handleSubmit}>
              <Box className="form">
                <CustomTextField
                  id="outlined-basic"
                  name="firstName"
                  className="register_field"
                  placeholder="First Name"
                  value={registerForm.values.firstName}
                  onChange={registerForm.handleChange}
                  error={
                    registerForm.touched.firstName &&
                    Boolean(registerForm.errors.firstName)
                  }
                  helperText={
                    registerForm.touched.firstName &&
                    Boolean(registerForm.errors.firstName) && (
                      <span style={errorTextStyle}>
                        {registerForm.errors.firstName}
                      </span>
                    )
                  }
                />
                <CustomTextField
                  id="outlined-basic"
                  name="lastName"
                  variant="outlined"
                  className="register_field"
                  placeholder="Last Name"
                  value={registerForm.values.lastName}
                  onChange={registerForm.handleChange}
                  error={
                    registerForm.touched.lastName &&
                    Boolean(registerForm.errors.lastName)
                  }
                  helperText={
                    registerForm.touched.lastName &&
                    Boolean(registerForm.errors.lastName) && (
                      <span style={errorTextStyle}>
                        {registerForm.errors.lastName}
                      </span>
                    )
                  }
                />
                <CustomTextField
                  id="outlined-basic"
                  name="email"
                  variant="outlined"
                  className="register_field"
                  placeholder="Email"
                  value={registerForm.values.email}
                  onChange={registerForm.handleChange}
                  error={
                    registerForm.touched.email &&
                    Boolean(registerForm.errors.email)
                  }
                  helperText={
                    registerForm.touched.email &&
                    Boolean(registerForm.errors.email) && (
                      <span style={errorTextStyle}>
                        {registerForm.errors.email}
                      </span>
                    )
                  }
                />
                <Box sx={{ display: "flex", gap: "15px" }}>
                  <CustomTextField
                    id="outlined-basic"
                    name="countryCode"
                    select
                    variant="outlined"
                    className="register_field"
                    placeholder="Email"
                    value={countryCode}
                    sx={{
                      color: "white",
                      width: "unset",
                      "& .MuiInputBase-input": {
                        color: "white",
                        maxWidth: "118px",
                      },
                      "& .MuiSelect-icon": {
                        color: "#838383 !important",
                      },

                      "& .MuiInputBase-input": {
                        paddingRight: {
                          // xs: "85px !important",
                        },
                        color: "white",
                      },

                      "& .MuiInputBase-root": {
                        // paddingRight: "5px",
                        "& .MuiSelect-select": {
                          width: "50px",
                        },
                      },
                    }}
                    onChange={(e) => setCountryCode(e.target.value)}
                    SelectProps={{
                      renderValue: (selected) => selected.split(" ").shift(),
                    }}
                  >
                    {countryCodes.map((value) => (
                      <MenuItem value={value}>{value}</MenuItem>
                    ))}
                  </CustomTextField>
                  <CustomTextField
                    id="outlined-basic"
                    name="phoneNumber"
                    variant="outlined"
                    className="register_field"
                    placeholder="Mobile Number"
                    value={registerForm.values.phoneNumber}
                    type="number"
                    onChange={registerForm.handleChange}
                    error={
                      registerForm.touched.phoneNumber &&
                      Boolean(registerForm.errors.phoneNumber)
                    }
                    helperText={
                      registerForm.touched.phoneNumber &&
                      Boolean(registerForm.errors.phoneNumber) ? (
                        <span style={errorTextStyle}>
                          {registerForm.errors.phoneNumber}
                        </span>
                      ) : null
                    }
                    sx={{
                      flexGrow: 1,
                      "& input[type=number]": {
                        MozAppearance: "textfield",
                      },
                      "& input[type=number]::-webkit-outer-spin-button": {
                        WebkitAppearance: "none",
                        margin: 0,
                      },
                      "& input[type=number]::-webkit-inner-spin-button": {
                        WebkitAppearance: "none",
                        margin: 0,
                      },
                    }}
                  />
                </Box>
                <CustomTextField
                  id="outlined-start-adornment"
                  name="password"
                  variant="outlined"
                  className="register_field"
                  placeholder="Password (8+ chars, upper, lower, number, symbol)"
                  type={showPass ? "text" : "password"}
                  value={registerForm.values.password}
                  onChange={registerForm.handleChange}
                  error={
                    registerForm.touched.password &&
                    Boolean(registerForm.errors.password)
                  }
                  helperText={
                    registerForm.touched.password &&
                    Boolean(registerForm.errors.password) && (
                      <span style={errorTextStyle}>
                        {registerForm.errors.password}
                      </span>
                    )
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showPass ? (
                            <Visibility sx={{ color: "white" }} />
                          ) : (
                            <VisibilityOff sx={{ color: "white" }} />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <CustomTextField
                  id="outlined-basic"
                  name="confirmPassword"
                  variant="outlined"
                  className="register_field"
                  placeholder="Confirm Password"
                  type={showConfPass ? "text" : "password"}
                  value={registerForm.values.confirmPassword}
                  onChange={registerForm.handleChange}
                  error={
                    registerForm.touched.confirmPassword &&
                    Boolean(registerForm.errors.confirmPassword)
                  }
                  helperText={
                    registerForm.touched.confirmPassword &&
                    Boolean(registerForm.errors.confirmPassword) && (
                      <span style={errorTextStyle}>
                        {registerForm.errors.confirmPassword}
                      </span>
                    )
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowConfPassword}
                          onMouseDown={handleMouseDownConfPassword}
                        >
                          {showConfPass ? (
                            <Visibility sx={{ color: "white" }} />
                          ) : (
                            <VisibilityOff sx={{ color: "white" }} />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <Box>
                  <Box className="t_c">
                    <Checkbox
                      sx={{
                        color: "rgba(0, 0, 0, 0.87)",
                        "& .MuiSvgIcon-root": {
                          fill: "#ffd8d8",
                          fontSize: 24,
                          borderRadius: "20%",
                        },
                      }}
                      name="terms"
                      id="registerTerms"
                      value={registerForm.values.terms}
                      onChange={registerForm.handleChange}
                      error={
                        registerForm.touched.terms &&
                        Boolean(registerForm.errors.terms)
                      }
                      helperText={
                        registerForm.touched.terms &&
                        Boolean(registerForm.errors.terms) && (
                          <span style={errorTextStyle}>
                            {registerForm.errors.terms}
                          </span>
                        )
                      }
                    />

                    <Typography component="label" htmlFor="registerTerms">
                      By clicking, you agree to our{" "}
                      <Link onClick={() => navigate("/termsandconditions")}>
                        Terms & Conditions
                      </Link>
                    </Typography>
                  </Box>
                  <Typography
                    component="p"
                    // className="css-1wc848c-MuiFormHelperText-root  Mui-error"
                  >
                    {registerForm.touched.terms && registerForm.errors.terms ? (
                      <span style={errorTextStyle}>
                        {registerForm.errors.terms}
                      </span>
                    ) : (
                      ""
                    )}
                  </Typography>
                </Box>

                <Button
                  className="Register"
                  type="submit"
                  sx={{ textTransform: "none !important" }}
                >
                  Register
                </Button>
              </Box>
            </form>
            <Box className="add-navi">
              <Typography component="p">
                Already have an account?{" "}
                <Link
                  onClick={() => {
                    navigate("/login");
                  }}
                >
                  Sign in
                </Link>
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Register;
